<template>
    <div>
        <div style="display: flex; flex-direction: row">
            <v-autocomplete
                v-if="title == null || title != 'Proveedor'"
                no-filter
                :rules="rules"
                v-model="id"
                :items="estados"
                :item-text="show"
                :item-value="itemvalue != null ? itemvalue : 'id'"
                :label="title"
                autocomplete="new-item-no-fill"
                :outlined="outlined"
                :dense="dense"
            >
                <template v-slot:item="data">
                    {{ data.item[show] }}
                    <v-spacer></v-spacer>
                    <v-icon
                        v-if="!disabled"
                        @click.stop="openEditDialog(data.item.id)"
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                    <v-icon
                        v-if="!disabled"
                        @click.stop="openDeleteDialog(data.item.id)"
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </template>
            </v-autocomplete>
            <proveedoresSelectVue
                v-else
                label="Proveedor"
                v-model="id"
                item-text="nombre"
                item-value="id"
                :outlined="outlined"
                :dense="dense"
                dynamic
                @edit="openEditDialog"
                @delete="openDeleteDialog"
            ></proveedoresSelectVue>
            <v-btn
                v-if="!disabled"
                style="margin-top: 10px"
                class="mx-2"
                fab
                dark
                small
                color="blue"
                @click="openDialog()"
            >
                <v-icon dark> mdi-plus </v-icon>
            </v-btn>
        </div>

        <!-- Modal para eliminar -->
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="delete_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteEstado()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Modal para crear/editar -->
        <v-dialog v-model="dialog" :max-width="maxWidth">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Crear/Editar {{ title }}
                </v-card-title>
                <v-card-text style="text-align: center">
                    <slot></slot>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="error" large @click="dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        v-if="this.update"
                        color="success"
                        large
                        @click="updateEstado()"
                        >Modificar</v-btn
                    >
                    <v-btn v-else color="success" large @click="createEstado()"
                        >Guardar</v-btn
                    >

                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import proveedoresSelectVue from "./proveedoresSelect.vue";
export default {
    components: {
        proveedoresSelectVue,
    },
    props: {
        title: {
            type: String,
        },
        estados: {
            type: Array,
            default: () => [],
        },
        show: {
            type: String,
            default: "nombre",
        },
        value: {
            type: [Number, String],
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Array,
            default: () => [],
        },
        itemvalue: {
            type: String,
            default: "id",
        },
        maxWidth: {
            type: String,
            default: "500px",
        },
        outlined: {
            type: Boolean,
            default: false,
        },
        dense: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            delete_dialog: false,
            dialog: false,
            update: false,
            index: -1,
            id: null,
            idToDelete: null,
        };
    },
    methods: {
        closeDialog() {
            this.dialog = false;
            this.delete_dialog = false;
        },
        createEstado() {
            this.$emit("create");
            // this.closeDialog();
        },
        deleteEstado() {
            this.$emit("delete", this.idToDelete);
            this.idToDelete = null;
            this.closeDialog();
        },

        updateEstado() {
            this.$emit("update");
            this.closeDialog();
        },
        getIndexOfId(id) {
            for (let i = 0; i < this.estados.length; i++) {
                if (this.estados[i].id == id) {
                    this.index = i;
                    break;
                }
            }
        },
        openDeleteDialog(id) {
            this.idToDelete = id;
            this.delete_dialog = true;
        },
        openDialog() {
            // No modificar this.id para no afectar el v-model del componente padre
            // this.$emit("getEstado", null);
            this.$emit("getItem", {});

            this.update = false;
            this.dialog = true;
        },

        openEditDialog(id) {
            this.id = id;

            this.$emit("getEstado", this.id);
            let item = this.estados.find((element) => element.id == this.id);
            if (item == null) {
                this.$emit("getItem", {});
            } else {
                this.$emit("getItem", item);
            }
            this.update = true;
            this.dialog = true;
        },
    },
    mounted() {},
    watch: {
        value(n) {
            this.id = n;
        },
        id(n) {
            if (n != null) {
                let elemento = null;
                if (this.title != "Proveedor") {
                    elemento = this.estados.find((element) => {
                        return element[this.itemvalue] == this.id;
                    });
                } else {
                    elemento = n;
                }
                this.$emit("changeElement", elemento);
                this.$emit("input", this.id);
            }
        },
    },
};
</script>
